export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatNumber = (value, options={}) => {
    if(value == null || value == undefined || isNaN(value)) return ""

    const {style="decimal",
        currency = "USD",
        minimumFractionDigits = 2,
        maximumFractionDigits = 2,
        locale = "en-US"
    } = options;

    return new Intl.NumberFormat(locale,{style,currency,minimumFractionDigits,maximumFractionDigits}).format(value)
} 

export const formatNumberWithCommas = (value) => {
    if(!value && value !== 0) return ""
    
    // Convert to string if it's a number
    const stringValue = typeof value === 'string' ? value : String(value)

     const numericValue = stringValue.replace(/[^0-9.]/g,"")

     const [integer, decimal] = numericValue.split(".")

     const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g,",")

     return decimal != undefined ? `${formattedInteger}.${decimal}` :formattedInteger;
}

export const formatPhone = (value) => {
    // Elimina todo lo que no sea dígito
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "");

    // Aplica el formato (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      return !match[2]
        ? match[1]
        : `(${match[1]}) ${match[2]}${match[3] ? "-" + match[3] : ""}`;
    }
    return value;
  };

export const formatIdentification = (value) => {
    const cleaned = value.replace(/\D/g, ""); // Quita todo lo que no sea número
    const match = cleaned.match(/^(\d{0,3})(\d{0,7})(\d{0,1})$/);

    if (match) {
        return !match[2]
        ? match[1]
        : !match[3]
        ? `${match[1]}-${match[2]}`
        : `${match[1]}-${match[2]}-${match[3]}`;
    }
    return value;
};

// Parser tolerante para campos JSON que vienen del backend (productos.campos,
// clientes.campos, solicitudes.campos, etc.). Acepta string JSON, objeto ya
// parseado, null/undefined o JSON inválido y siempre devuelve un objeto plano.
// Pensado para reemplazar `JSON.parse(x.campos)` directos que rompen cuando el
// valor viene en null o cuando ya fue parseado (caso `JSON.parse(object)` →
// "[object Object]" is not valid JSON).
export const parseCampos = (raw) => {
    if (raw == null || raw === '') return {};
    if (typeof raw === 'object') return raw;
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
};

export function getMySQLDateTime(date = new Date()) {
    const pad = (n) => n.toString().padStart(2, '0');
  
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
  
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  

  // Convierte un número a su representación en texto en español (hasta miles de millones, sin decimales)
  export function numeroATexto(num) {
    if (typeof num !== "number" || !isFinite(num)) return "";

    const unidades = [
      "", "uno", "dos", "tres", "cuatro", "cinco",
      "seis", "siete", "ocho", "nueve", "diez",
      "once", "doce", "trece", "catorce", "quince",
      "dieciséis", "diecisiete", "dieciocho", "diecinueve", "veinte"
    ];
    const decenas = [
      "", "", "veinte", "treinta", "cuarenta",
      "cincuenta", "sesenta", "setenta", "ochenta", "noventa"
    ];
    const centenas = [
      "", "ciento", "doscientos", "trescientos", "cuatrocientos",
      "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"
    ];

    if (num === 0) return "cero";
    if (num === 100) return "cien";

    function seccion(n, divisor, singular, plural) {
      const cientos = Math.floor(n / divisor);
      const resto = n - cientos * divisor;

      let texto = "";
      if (cientos === 0) return "";
      if (cientos === 1) {
        texto = singular;
      } else {
        texto = numeroATexto(cientos) + " " + plural;
      }
      return texto + (resto > 0 ? " " : "");
    }

    function decenasYUnidades(n) {
      if (n < 21) return unidades[n];
      if (n < 30) return "veinti" + unidades[n - 20];
      let dec = Math.floor(n / 10);
      let uni = n % 10;
      return decenas[dec] + (uni ? " y " + unidades[uni] : "");
    }

    function centenasYDecenas(n) {
      if (n < 100) return decenasYUnidades(n);
      let cen = Math.floor(n / 100);
      if (n === 100) return "cien";
      return centenas[cen] + " " + decenasYUnidades(n % 100);
    }

    let texto = "";

    texto += seccion(num, 1_000_000_000, "mil millones", "mil millones");
    num = num % 1_000_000_000;

    texto += seccion(num, 1_000_000, "un millón", "millones");
    num = num % 1_000_000;

    // Miles
    if (num >= 1000) {
      if (Math.floor(num / 1000) === 1) {
        texto += "mil";
      } else {
        texto += numeroATexto(Math.floor(num / 1000)) + " mil";
      }
      if (num % 1000 > 0) texto += " ";
    }

    texto += centenasYDecenas(num % 1000);

    return texto.trim().replace(/\s+/g, " ");
  }

